<template>
	<div>
		<div class="sf-search-layout__body__container">
			<sf-search-layout>
				<el-row :gutter="20">
					<el-col :span="3">
						<div class="sf-input-group-wrapper">
							<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001224') }}</span>
							<el-date-picker
								type="year"
								:value="searchParams.strDt"
								@input="value => changeMulti({ key: 'strDt', value })"
								value-format="yyyy"
								:placeholder="getMessage_('QWCC001224')"
							/>
						</div>
					</el-col>
					<el-col :span="4">
						<multi-select-combo
							:label="getMessage_('QWCC001337')"
							paramKey="eqipKndCd"
							:options="getEqipKndCd_"
							@multiCommChange="changeMulti"
						></multi-select-combo>
					</el-col>
					<el-col :span="4">
					<search-input
						:label="getMessage_('QWCC001317')"
						paramKey="mesEqipNo"
						@commInput="changeMulti"
						:clearable="true"
						:propData="searchParams.mesEqipNo"
					>
					</search-input>
				</el-col>
				</el-row>
				<template slot="button">
					<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
						{{ getButtonMsg_(scrId, 'CR') }}
					</sf-button>
				</template>
			</sf-search-layout>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import MultiSelectCombo from '@qms/Components/MultiSelectCombo';
import SearchInput from '@qms/Components/SearchInput';

export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {
			searchYear: this.$moment().format('YYYY')
		};
	},
	components: { MultiSelectCombo,SearchInput },
	async created() {
		try {
			await this.getCommCodes_({ key: 'eqipKndCdList', codeType: 'EQIP_KND' });
			await this.searchList();
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message });
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		changeMulti({ key, value }) {
			if (key === 'strDt') {
				this.setSearchParam_({ key: 'endDt', value: value + '12' });
				value += '01';
			}
			this.setSearchParam_({ key, value });
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			try {
				if (!this.isMmcAdmin) throw new Error(this.getMessage_('QWCC001923')); //해당메뉴에 접근 권한이 없습니다. 관리자에게 권한을 요청하세요.
				await this.getList_();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			} finally {
				this.$emit('doLoad');
				this.$sf_toggleLoading(false);
			}
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
